import { render } from "./RootPage.vue?vue&type=template&id=77e422a6&ts=true"
import script from "./RootPage.vue?vue&type=script&lang=ts"
export * from "./RootPage.vue?vue&type=script&lang=ts"

import "./RootPage.vue?vue&type=style&index=0&id=77e422a6&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__